import React, { useState } from "react";
import { Heart, Loader2 } from "lucide-react";
import api from "../lib/api";

// Private "Inner Circle" favorite toggle for a member.
export const FavoriteButton = ({ memberId, initial = false, onChange, size = 18, className = "" }) => {
  const [fav, setFav] = useState(initial);
  const [busy, setBusy] = useState(false);

  const toggle = async (e) => {
    e?.stopPropagation?.();
    e?.preventDefault?.();
    if (busy) return;
    setBusy(true);
    const next = !fav;
    setFav(next);
    try {
      const { data } = await api.post(`/members/${memberId}/favorite`);
      setFav(data.favorited);
      onChange?.(data.favorited);
    } catch {
      setFav(!next);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      data-testid={`favorite-button-${memberId}`}
      title={fav ? "Remove from your Inner Circle" : "Add to your Inner Circle"}
      aria-pressed={fav}
      className={`transition-colors ${fav ? "text-[#14A89A]" : "text-zinc-500 hover:text-[#14A89A]"} ${className}`}
    >
      {busy ? <Loader2 size={size} className="animate-spin" /> : <Heart size={size} strokeWidth={1.75} fill={fav ? "#14A89A" : "none"} />}
    </button>
  );
};
